import React from 'react';
import { useLocale } from '../i18n/LocaleContext';
import { AlertIcon, SearchOffIcon } from './Icons';

export function EventCardSkeleton() {
  return (
    <div className="card card--skeleton" aria-hidden="true">
      <div className="card__media" />
      <div className="card__body">
        <div className="skeleton" style={{ width: '45%', height: 11 }} />
        <div className="skeleton" style={{ width: '85%', height: 17, marginTop: 4 }} />
        <div className="skeleton" style={{ width: '60%', height: 13, marginTop: 4 }} />
        <div className="card__footer">
          <div className="skeleton" style={{ width: 74, height: 14 }} />
          <div className="skeleton" style={{ width: 56, height: 13 }} />
        </div>
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 6 }) {
  return (
    <div className="events-grid">
      {Array.from({ length: count }, (_, index) => (
        <EventCardSkeleton key={index} />
      ))}
    </div>
  );
}

export function EmptyState({ onReset }) {
  const { t } = useLocale();

  return (
    <div className="state">
      <span className="state__icon">
        <SearchOffIcon />
      </span>
      <h2 className="state__title">{t('empty.title')}</h2>
      <p className="state__body">{t('empty.body')}</p>
      {onReset && (
        <button type="button" className="btn" onClick={onReset}>
          {t('empty.reset')}
        </button>
      )}
    </div>
  );
}

export function ErrorState({ onRetry }) {
  const { t } = useLocale();

  return (
    <div className="state">
      <span className="state__icon">
        <AlertIcon />
      </span>
      <h2 className="state__title">{t('error.title')}</h2>
      <p className="state__body">{t('error.body')}</p>
      {onRetry && (
        <button type="button" className="btn btn--accent" onClick={onRetry}>
          {t('error.retry')}
        </button>
      )}
    </div>
  );
}
